<template>
  <div class="component-wrapper secondary d-flex flex-column">
    <div class="d-flex align-center">
      <h1 class="white--text font-weight-bold text-h5 px-2">
        {{ $t("routes.title") }}
      </h1>
      <v-btn icon @click="step = 1" v-if="step == 2" small>
        <v-icon color="white" size="17">mdi-arrow-left</v-icon>
      </v-btn>
    </div>
    <span class="caption grey--text px-2 mb-2">
      {{ step == 1 ? $t("routes.step1") : $t("routes.step2") }}
    </span>

    <v-container v-if="step == 1">
      <v-row>
        <v-col
          v-for="(category, i) in categories"
          :key="i"
          cols="6"
          class="card d-flex flex-column"
          @click="onCategorySelect(category)"
        >
          <div class="card-2 d-flex flex-column align-center justify-center">
            <v-icon color="white" size="45"> {{ category.icon }}</v-icon>
            <span class="white--text body-1 text-center">
              {{ category.name }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="step == 2">
      <v-row>
        <v-col
          v-for="(island, i) in islands"
          :key="i"
          cols="6"
          class="card d-flex flex-column"
          @click="onIslandSelect(island)"
        >
          <div class="card-2 d-flex flex-column align-center justify-center">
            <v-icon color="white" size="45"> mdi-island</v-icon>
            <span class="white--text body-1 text-center">
              {{ island.name }}
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
export default {
  async created() {
    try {
      const categories = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/path-categories`
      );
      this.categories = categories.data;

      const areas = await axios.get(`${process.env.VUE_APP_BASE_URL}/areas`);
      const sortedAreas = areas.data.areas.sort((a, b) => {
        return a.weight - b.weight;
      });
      this.islands = sortedAreas;
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      step: 1,
      islands: [],
      categories: [],
    };
  },

  methods: {
    ...mapMutations(["setFilters"]),
    onCategorySelect(category) {
      this.category = category;
      this.step = 2;
    },

    onIslandSelect(island) {
      this.setFilters({ island: island.id, category: this.category.id });
      this.$router.push(`/routes/results`);
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  height: 150px !important;
  width: 100px !important;
}

.card-2 {
  height: 100% !important;
  width: 100% !important;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
}

.card-2:hover {
  transition: 0.3s ease;
  background: rgba(255, 255, 255, 0.3);
}
</style>